import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ErrorMessage } from '@espacePro/components/_common/Form';
import Btn from '../../main-app/components/buttons/Btn';
import { ToolbarButton } from './ToolbarButton';
import { FONT_FAMILY_MAIN } from '../../main-app/theme';

const AnswerBoxContainer = styled.div`
  flex: 1;
  width: 100%;
`;

const AnswerBoxArrowLeft = styled.svg`
  position: absolute;
  top: 10px;
  left: -18px;
`;

const AnswerBoxTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  line-height: 1.44;
  letter-spacing: 0.2px;
  color: #354354;
  margin-bottom: 16px;
`;

const AnswerBoxField = styled.textarea`
  width: 100%;
  resize: vertical;
  margin-bottom: 18px;
  padding: 14px 16px 5px;
  font-size: 16px;
  line-height: 1.25;
  letter-spacing: 0.2px;
  color: #354354;
  outline: none;
  border: 1px solid #cecece;
  border-radius: 2px;
  font-family: ${FONT_FAMILY_MAIN};

  &:focus {
    border: 1px solid #23c4f8;
  }
`;

const AnswerBoxFormToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 22px;
`;

const AnswerBoxButton = styled(Btn)`
  background-color: #4a90e2;
  border-radius: 4px;
  font-size: 16px;
  font-weight: bold;
  color: #ffffff;
  padding: 12px 24px;
  border: none;
`;

const AnswerForm = ({
  value, onChange, onSubmit, isSending, onCancel, hasError, isModifyView,
}) => (
  <AnswerBoxContainer>
    <AnswerBoxArrowLeft
      width="19"
      height="25"
      viewBox="0 0 19 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#eef1f6"
        d="M0 .024c6.37.117 12.545 1.023 18.432 2.622.111-.395.111 7.056 0 22.354-1.148-11.2-8.636-20.374-18.432-24.976z"
      />
    </AnswerBoxArrowLeft>
    <AnswerBoxTitle>Votre réponse</AnswerBoxTitle>
    <AnswerBoxField
      value={value}
      onChange={onChange}
      rows="8"
    />
    {hasError && <ErrorMessage>Une erreur est survenue, veuillez réessayer</ErrorMessage>}
    <AnswerBoxFormToolbar>
      <AnswerBoxButton
        onClick={onSubmit}
        isLoading={isSending}
        text={isModifyView ? 'Enregistrer' : 'Répondre'}
      />
      <ToolbarButton bold onClick={onCancel}>
        Annuler
      </ToolbarButton>
    </AnswerBoxFormToolbar>
  </AnswerBoxContainer>
);

AnswerForm.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSending: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  isModifyView: PropTypes.bool,
};

AnswerForm.defaultProps = {
  value: '',
  isSending: false,
  hasError: false,
  isModifyView: false,
};

export { AnswerForm };
